module.exports = __webpack_public_path__ + "img/IgniteGroup.2c455357.jpg";